<template>
  <section>
    <a-row>
      <a-col :span="12" class="selector__label"> Canal </a-col>
      <a-col :span="12" class="selector__label"> Identificador </a-col>
    </a-row>

    <CustomScrollbar class="scroll-bar">
      <channel-input
        v-if="toSequence"
        :withoutVoice="withoutVoice"
        :key="1"
        :value="itemsVoiceSequenceSelected?.[0]"
        :selected="itemsVoiceSequenceSelected"
        :selectedValues="[ 1 ]"
        :items="itemsVoiceSequence"
        :disabled="true"
        :showTooltipDelete="false"
        :to-sequence="toSequence"
        :chatAndVoiceInboundChannel="chatAndVoiceInboundChannel"
      />

      <channel-input
        v-for="(item, index) in slugs"
        :withoutVoice="withoutVoice"
        :key="item.id"
        :value="item"
        :selected="slugs"
        :disabled="disabled || item.disabled"
        :showTooltipDelete="item.disabled"
        :selectedValues="value"
        :items="currentItems"
        :show-pop="index >= 0"
        :show-sms="toSequence"
        :to-sequence="toSequence"
        @change="handleInputChange"
        @popSlug="handlePopSlug"
        :chatAndVoiceInboundChannel="chatAndVoiceInboundChannel"
        :tooltipDisabled="tooltipDisabled"
        :is-queue= "isQueue"
        :is-chatbot= "isChatbot"
        :blocked-identifiers="blockedIdentifiers"
      />
    </CustomScrollbar>
    <div class="line-gray" />
    <div class="add-channels">
      <a-tooltip>
        <template #title v-if="hasItemsHidden || (tooltipDisabled && disabled)">
          {{ tooltipDisabled && disabled ? tooltipDisabled : 'Completa los datos del identificador' }}
        </template>
        <a-button type="link" @click="handleAddInput" :loading="loadingInitial" :disabled="disabled || hasItemsHidden || loadingInitial">
          <PlusOutlined />
          Agregar canal
        </a-button>
      </a-tooltip>
    </div>
  </section>
</template>

<script>
import ChannelInput from "@/app/shared/components/inputs/ChannelInput.vue";
import { fetchCustomerChannels, fetchAvailableChannels } from "@/app/shared/services";
import { fetchWhatsappBalance } from "@/app/settings/services";
import { PlusOutlined } from "@ant-design/icons-vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { ChannelType } from "@/app/shared/utils/enums";
import { TypeBilling } from "@/app/workspace/utils/enums";

import { QueuesEvent } from "@/app/queues/domain/events";
import EventBus from "@/app/shared/utils/eventBus";
import { defineComponent, ref } from "vue";

const channelsLimit = 5;

export default defineComponent({
  components: {
    ChannelInput,
    PlusOutlined,
    CustomScrollbar,
  },
  props: {
    /** Array de ids de canales */
    value: { required: true, type: Array },
    showAll: { required: true, type: Boolean, default: false },
    channel: { required: false, type: Number, default: 0 },
    withoutVoice: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledIdentifiers: { type: Array, default: () => [] },
    toSequence: { type: Boolean, default: false },
    portfolioId: { type: Number, default: null },
    chatAndVoiceInboundChannel: { type: Boolean, default: false},
    showSms: { type: Boolean, default: false },
    tooltipDisabled: { type: String, default: null },
    isQueue: {type: Boolean, default: false},
    isChatbot: {type: Boolean, default: false},
    /** Mapa id de identificador -> nombre del Agente IA que ya lo usa */
    blockedIdentifiers: { type: Object, default: () => ({}) },
    skipFilterQueue: { type: Boolean, default: false },
  },
  setup() {
    const slugs = ref([]);
    const lastPosition = ref(0);

    const itemsVoiceSequence = ref([
      { id: 1, channel_name: "Llamadas", channel_icon: new URL(`../../assets/channels/calls.svg`, import.meta.url).href, 
      channel_id: 1, provider_name: "Securitec", alias: "Número aleatorio", disabled: true, identifier: '', type: 1 }
    ]);

    const itemsVoiceSequenceSelected = ref([
      { id: 1, type: 1, identifier: '', alias: 'Número aleatorio', disabled: true }
    ]);
    return {
      slugs,
      itemsVoiceSequence,
      itemsVoiceSequenceSelected,
      lastPosition,
    };
  },
  data() {
    return {
      channels: [],
      channelsAvailable: [],
      loadingInitial: false,
      balance_voice: 0,
      type_billing_voice: null,
    };
  },
  computed: {
    inputs() {
      const array = this.value;
      return array.map((id) => this.channels.find((item) => item.id === id));
    },
    showAddInput() {
      return this.slugs.length < channelsLimit;
    },
    currentItems() {
      return this.showAll ? this.channels : this.channelsAvailable;
    },
    hasItemsHidden () {
      const itemIndex = this.value.findIndex((item) => item == null);
      return itemIndex >= 0;
    }
  },
  watch: {
    async portfolioId() {
      await this.fetchChannels();
      this.slugs = [];
    },
    async channel() {
      this.$emit("update:value", []);
      this.slugs = [];
      await this.initialCharge();
    }
  },
  async created() {
    await this.initialCharge();
  },
  methods: {
    async initialCharge() {
      this.loadingInitial = true;
      await this.fetchChannels();
      await this.setSlugs();

      EventBus.$on(QueuesEvent.QUEUE_MODAL_ADD_OPENED, () => this.setSlugs());
      EventBus.$on(QueuesEvent.QUEUE_MODAL_EDIT_OPENED, () => this.setSlugs());
      this.loadingInitial = false;
      this.$emit('finishLoadingInitial');
    },
    // TODO: Refactor
    async fetchChannels() {
      await this.fetchWhatsappVoiceBalance();
      const channels = await fetchCustomerChannels({ toSequence: this.toSequence, portfolioId: this.portfolioId });
      if (!this.toSequence) {
        const response2 = await fetchAvailableChannels({
          toSequence: this.toSequence,
          skipFilterQueue: this.skipFilterQueue
        });
        const channels2 = response2.filter((item) => item.channel_id != ChannelType.Email || item.alias || item.associate);
        
        this.channels = channels.filter((item) => {
          const channelFilter =
            this.channel === ChannelType.Multichannel ? true : item?.channel_id === this.channel;

          const hasChannelFilter = this.channel ? channelFilter : true;

          return this.showAll
            ? item?.channel_id !== ChannelType.Voice &&
                (this.chatAndVoiceInboundChannel || item?.channel_id !== ChannelType.VoiceInbound) &&
                item?.status === 1
            : item?.channel_id !== 2 && this.isChannelActive(item) && hasChannelFilter;
        });
        console.log(channels.filter((el) => el.channel_id == 5), 'channels')

        this.channelsAvailable = channels2.filter((item) => {
          const channelFilter =
            this.channel === ChannelType.Multichannel ? true : item?.channel_id === this.channel;

          const hasChannelFilter = this.channel ? channelFilter : true;

          if (item.channel_id == 5) console.log(hasChannelFilter, 'hasChannelFilter')
          return (this.showAll
            ? item?.channel_id !== ChannelType.Voice && item?.channel_id !== ChannelType.VoiceInbound
            : item?.channel_id !== 2 && item?.status == 1 && hasChannelFilter) && ( !this.isQueue || item?.channel_id !== ChannelType.Email ) && 
            this.validateChatbotMultichannel(item);
        });
      } else {
        this.channels = channels.filter((item) => (item?.status == 1));
        this.channelsAvailable = channels.filter((item) => (item?.status == 1));
      }

      console.log(this.channelsAvailable.filter((el) => el.channel_id == 5), 'channels available')

      this.value.map((id) => {
        const channel = this.channels.find((item) => item?.id == id);

        if (this.channelsAvailable?.some((c) => c?.id === channel?.id)) return;
        this.channelsAvailable.push(channel);
      });
    },
    validateChatbotMultichannel(item) {
      if (this.channel == ChannelType.Multichannel)
        return item?.channel_id !== ChannelType.Email;

      return true;
    },
    async setSlugs() {
      const items = this.value.map((id) => {
        const channel = this.channels.find((item) => item.id == id);
        this.lastPosition = this.value.indexOf(id);
        return {
          id: id,
          type: channel?.channel_id,
          identifier: channel?.associate,
          alias: channel?.alias,
          disabled: this.disabledIdentifiers.includes(id),
          position: this.value.indexOf(id),
        };
      });
      const emptyInput = this.toSequence ? [] : [{
        position: 0,
        id: undefined,
        type: undefined,
        identifier: undefined,
        alias: undefined,
        disabled: false,        
      }];
      this.slugs = items?.length > 0 ? items : emptyInput;
    },
    handleInputChange(event) {
      if (event.id != null) {
        const values = [];
        this.slugs.map((item) => values.push(item.id));
        this.$emit("update:value", values);
      } else{
        this.$emit("selectChannel");
        const values = [];
        this.slugs.map((item) => {
          if (event.index === item.id) {
            item.id = null;
          }
          values.push(item.id);
        });
        this.$emit("update:value", values);
      }
    },
    handleAddInput() {
      this.lastPosition += 1;
      const emptyInput = {
        position: this.lastPosition,
        id: undefined,
        type: undefined,
        identifier: undefined,
        alias: undefined,
      };
      this.slugs.push(emptyInput);
      const value = this.value;
      value.push(null);
      this.$emit("update:value", value);
    },
    handlePopSlug(event) {
      this.slugs = this.slugs.filter((item) => item.position != event.position );
      const values = [];
      this.slugs.map((item) => values.push(item.id));
      this.$emit("update:value", values);
    },
    async fetchWhatsappVoiceBalance() {
      const response = await fetchWhatsappBalance("whatsapp-voice");

      this.balance_voice = response.balance;
      this.type_billing_voice = response.type_billing;
    },
    isBlockByWhatsappVoiceBalance() {
      return (
        this.balance_voice <= 0 &&
        this.type_billing_voice === TypeBilling.PrePayment
      );
    },
    isChannelActive(item) {
      const blockedByWABalance = item?.channel_id === ChannelType.WhatsappVoice && this.isBlockByWhatsappVoiceBalance();
      return item?.status === 1 || (item?.status === 2 && blockedByWABalance);
    }
  },
});
</script>

<style lang="sass" scoped>
.selector
  &__label
    color: $gray-9
    font-weight: 600
    margin: 4px 0
.add-channels
  margin-top: 10px
  display: flex
  justify-content: center
.line-gray
  border: 1px solid #E8E8E8
  width: 100%
.scroll-bar
  max-height: 250px
</style>
